import { ListDataRequest, ListDataResponse } from '../../models/List';
import {
  AetherInventoryReportRecord,
  AetherInventorySku,
  AetherInventoryUpdate,
  ListManagementProduct,
  ListProductFilters,
  ManagementProduct,
} from '../../models/ManagementProduct';
import { FullProduct, ProductReorderContact } from '../../models/Product';
import { aetherApi } from './aetherApi';

export const productApi = aetherApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductManagementList: builder.query<
      ListDataResponse<ListManagementProduct, ListProductFilters>,
      ListDataRequest<ListProductFilters>
    >({
      query: (params) => ({
        url: `api/v2/product/front-management/list`,
        body: params,
        method: 'POST',
      }),
    }),
    getManagementProduct: builder.query<ManagementProduct, { id: string }>({
      query: ({ id }) => ({
        url: `api/v2/product/front-management/${id}`,
        method: 'GET',
      }),
      providesTags: (result, _, { id }) => (result ? [{ type: 'ManagementProduct', id }] : []),
    }),
    getAetherInventory: builder.query<AetherInventorySku[], string>({
      query: (id) => ({
        url: `api/v2/product/front-management/${id}/aether-inventory`,
      }),
      providesTags: (result, _, id) => (result ? [{ type: 'Inventory', id }] : []),
    }),
    updateAetherInventory: builder.mutation<AetherInventorySku[], AetherInventoryUpdate>({
      query: (body) => ({
        url: `api/v2/product/front-management/${body.id}/aether-inventory`,
        method: 'PUT',
        body,
      }),
      onQueryStarted: async (update, { dispatch, queryFulfilled }) => {
        try {
          const { data: updatedProduct } = await queryFulfilled;
          dispatch(
            productApi.util.updateQueryData('getAetherInventory', update.id, (_) => {
              return updatedProduct;
            }),
          );
        } catch (error) {
          console.error(error);
        }
      },
    }),
    getInventoryReportByWarehouse: builder.query<AetherInventoryReportRecord[], string>({
      query: (warehouseId) => `api/v2/product/front-management/inventory-report/${warehouseId}`,
    }),
    getProductReorderContact: builder.query<ProductReorderContact, string>({
      query: (id) => ({
        url: `api/v2/product/front/${id}/reorder-contact`,
      }),
      providesTags: (result, _,id ) => (result ? [{ type: 'ReorderContact', id }] : []),
    }),
    getRelatedProducts: builder.query<FullProduct[], string>({
      query: (id) => ({
        url: `api/v1/products/${id}/relatedProducts`,
      }),
    }),
  }),
});

export const {
  useGetProductManagementListQuery,
  useGetManagementProductQuery,
  useUpdateAetherInventoryMutation,
  useGetAetherInventoryQuery,
  useGetInventoryReportByWarehouseQuery,
  useGetProductReorderContactQuery,
  useGetRelatedProductsQuery,
} = productApi;
